export default __webpack_public_path__ + "static/media/photo--sm--kara2.73a1ac17.jpg";